// TennisTrack Hub — Navbar Principale | 029 Project
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PannelloNotifiche from './PannelloNotifiche';
import './Navbar.css';

const Navbar = () => {
  const { utente, logout } = useAuth();
  const location = useLocation();
  const [menuAperto, setMenuAperto] = useState(false);

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <nav className="navbar">
      {/* Brand */}
      <Link to="/dashboard" className="navbar-brand">
        <img src="/img/logo_tennistrack_300x800.png" alt="TennisTrack Hub" className="navbar-logo" />
      </Link>

      {/* Nav links — desktop */}
      <div className="navbar-links">
        <Link to="/dashboard" className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}>
          🏠 Dashboard
        </Link>
        <Link to="/atleti" className={`nav-link ${isActive('/atleti') ? 'active' : ''}`}>
          🎾 Atleti
        </Link>
        <Link to="/atleti" className={`nav-link ${isActive('/allenamenti') ? 'active' : ''}`}
          onClick={e => { if (isActive('/allenamenti')) e.preventDefault(); }}
          style={{ display: isActive('/allenamenti') ? 'flex' : 'none' }}
        >
          💪 Allenamenti
        </Link>
        <Link to="/template" className={`nav-link ${isActive('/template') ? 'active' : ''}`}>
          📋 Template
        </Link>
        {utente?.piano !== 'premium' && (
          <Link to="/premium" className={`nav-link nav-link-premium ${isActive('/premium') ? 'active' : ''}`}>
            ⭐ Premium
          </Link>
        )}
      </div>

      {/* Utente */}
      <div className="navbar-user">
        <PannelloNotifiche />
        <Link
          to="/premium"
          className={`piano-badge piano-${utente?.piano}`}
          title={utente?.piano !== 'premium' ? 'Fai upgrade a Premium' : 'Piano Premium attivo'}
          style={{ textDecoration: 'none' }}
        >
          {utente?.piano === 'premium' ? '⭐ PREMIUM' : utente?.piano?.toUpperCase()}
        </Link>
        <div className="navbar-avatar" onClick={() => setMenuAperto(!menuAperto)}>
          {utente?.nome?.[0]}{utente?.cognome?.[0]}
        </div>

        {menuAperto && (
          <div className="navbar-dropdown">
            <div className="dropdown-info">
              <strong>{utente?.nome} {utente?.cognome}</strong>
              <span>{utente?.email}</span>
            </div>
            <hr />
            <Link to="/profilo" className="dropdown-link" onClick={() => setMenuAperto(false)}>
              👤 Il mio profilo
            </Link>
            {utente?.piano !== 'premium' && (
              <Link to="/premium" className="dropdown-upgrade-link" onClick={() => setMenuAperto(false)}>
                ⭐ Passa a Premium
              </Link>
            )}
            <Link to="/admin" className="dropdown-link dropdown-link-admin" onClick={() => setMenuAperto(false)}>
              🛠 Admin
            </Link>
            <hr />
            <button onClick={logout} className="dropdown-btn-logout">🚪 Esci</button>
          </div>
        )}
      </div>

      {/* Hamburger mobile */}
      <button className="navbar-hamburger" onClick={() => setMenuAperto(!menuAperto)}>
        ☰
      </button>
    </nav>
  );
};

export default Navbar;
